/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerType } from '../../models/customer-type';
import { GetCompanyCustomersResponse } from '../../models/get-company-customers-response';

export interface GetApiAdministrativeV1IdCustomers$Json$Params {

/**
 * The unique identifier of the company.
 */
  id: number;

/**
 * The Type of the customer, ex LAC.
 */
  Type?: CustomerType;

/**
 * The page number for pagination.
 */
  Page?: number;

/**
 * The number of items per page.
 */
  PageSize?: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
}

export function getApiAdministrativeV1IdCustomers$Json(http: HttpClient, rootUrl: string, params: GetApiAdministrativeV1IdCustomers$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompanyCustomersResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiAdministrativeV1IdCustomers$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('Type', params.Type, {});
    rb.query('Page', params.Page, {});
    rb.query('PageSize', params.PageSize, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCompanyCustomersResponse>;
    })
  );
}

getApiAdministrativeV1IdCustomers$Json.PATH = '/private/v1/companies/{id}/customers';
